import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { navigateToStatusChangeSchedule } from '../lib/inspect-schedule-prefill';
import { ActionTip } from './ActionTip';
import { IndexerIcon } from './IndexerIcon';

export function InspectScheduleNotifyAction({
  url,
  source,
}: {
  url: string;
  source: string;
}) {
  const navigate = useNavigate();

  return (
    <ActionTip tip="زمان‌بندی اعلان تغییر وضعیت">
      <Button
        size="sm"
        variant="link"
        className="if-table-action"
        aria-label="زمان‌بندی اعلان تغییر وضعیت"
        onClick={() => navigateToStatusChangeSchedule(navigate, [url], source)}
      >
        <IndexerIcon name="calendar-event" />
      </Button>
    </ActionTip>
  );
}
